<script>
</script>

<footer>
    <p>Alorem Law @2021</p>
    <a href="https://github.com/akifsahinkorkmaz">dev's github</a>
</footer>

<style>
    footer{
        width: 100vw;
        margin-top: 3rem;
        height: 12vh;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-wrap: wrap;
        background-color: #fff;

        -webkit-box-shadow: inset -3px 10px 15px 3px rgba(20, 22, 21, 0.75);
        -moz-box-shadow: inset -3px 10px 15px 3px rgba(20, 22, 21, 0.75);
        box-shadow: inset -3px 10px 15px 3px rgba(20, 22, 21, 0.75);
    }
    footer *{
        margin: 1rem;
    }
    a{
        color: #D5B36B;
    }
</style>